<template>
  <el-skeleton class="skeleton" v-bind="$attrs" v-on="$listeners" :animated="animated">
    <slot slot="template" name="template"></slot>
    <slot></slot>
  </el-skeleton>
</template>
<script>
export default {
  name: 'Skeleton',
  props: {
    animated: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.skeleton {
  font-size: 0;
  ::v-deep {
    .el-skeleton__p {
      display: block;
    }
  }
}
</style>
